import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

const baseEventParams = {
  page: '/deceso/resumen-de-contratacion',
  page_title: 'Deceso - Resumen de Contratacion',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const pageViewDataLayer = (plan: DataLayerPlanType, insured: string, withAgent: boolean) => ({
  ...baseEventParams,
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

const goBackDataLayer = (plan: DataLayerPlanType, insured: string) => ({
  ...baseEventParams,
  action_type: 'click',
  action: 'Click - Volver',
  product_type: plan,
  asegurados: insured,
});

export const checkoutPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: pageViewDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), withAgent),
  });

export const checkoutGoBackClick = (planCode: string, insured: number) =>
  BaseDataLayer({ eventParams: goBackDataLayer(PLAN_CODE_MAP[planCode], insured.toString()) });
